<template>
  <p class="field field_all">
    <app-checkbox :name="name" ref="checkbox" :title="translations.all" :checked="checked" @change="$emit('change', $event)" />
    <app-button-move />
  </p>
</template>

<script>
export default {
  name: 'item-move-everything',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    pictures: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    translations() {
      return {
        all: this.$gettext('Vše')
      }
    }
  },
  methods: {
    focusCheckbox() {
      this.$refs.checkbox.focus()
    }
  }
}
</script>
